import {BackButton} from "../../BackButton.tsx";
import Routing from "../../../../Routing.ts";

function ReportErrorHeaderComponent() {
    return (
        <div className={'selfcare-page-summary'}>
            <h2>Fejlmeld dit internet</h2>
            <p>Hvis du oplever problemer med dit internet, kan du fejlmelde det her.</p>
            <BackButton default_url={Routing.Selfcare.Internet}/>
        </div>
    );
}

export default ReportErrorHeaderComponent;
